import { memo } from "react";
import { Container } from "../../common/HtmlTags/Container/Container";
import { Paragraph } from "../../common/HtmlTags/Paragraph/Paragraph";
import { Span } from "../../common/HtmlTags/Span/Span";
import ImageSlider from "../../common/ImageSlider/ImageSlider";
import AuthBannerImg from "../../../assets/images/Auth-Banner.png";
import "./AuthBanner.css";

const AuthBanner = memo(() => {
  const bannerImages = Array(3).fill(AuthBannerImg);

  return (
    <Container className="auth-banner-left" data-testid="auth-banner-left">
      <ImageSlider images={bannerImages} />
      <Container className="auth-banner-content-wrap">
        <Paragraph className="auth-banner-text">
          <Span>Have something you once loved, but don't use anymore?</Span>
          <Span>Pass it on — let someone else cherish it.</Span>
        </Paragraph>
      </Container>
    </Container>
  );
});

AuthBanner.displayName = "AuthBanner";

export default AuthBanner;

/**
 * AuthBanner component displays a promotional banner with an image slider and motivational text.
 * Utilizes a set of static images and styled content to encourage users to pass on items they no longer use.
 * Designed for use in authentication or landing page layouts.
 *
 * @component
 * @example
 * // Basic usage
 * <AuthBanner />
 *
 * @remarks
 * The banner uses a static set of images and styled text to create an engaging visual for users.
 * It is memoized for performance optimization.
 */
